// TODO: Try to override i18n.t function in the prototype
export function getI18nKeyByContext(key) {
    if (navigator.product === 'ReactNative') {
        return key;
    }
    // @ts-ignore
    return typeof APP !== 'undefined' && APP?.isExternalProvider ? `${key}_xbees` : key;
}
